import { Button, Result } from 'antd'
import queryString from 'query-string'
import React from 'react'
import { Redirect, RouteComponentProps } from 'react-router'
import { AsyncComponent } from '../../atom/async-component/async-component'
import { Loading } from '../../atom/loader'
import { Links } from '../../components/routes/paths'
import { LoggedInPath } from '../../components/routes/routes'
import { log } from '../../logger'
import { cognitoAuth } from '../../services/auth/cognito'
import { useAppState } from '../../state'

const onSuccessRedirection = (redirectUrl: string = LoggedInPath) => {
  log('cognito login completed correctly, redirecting to user dashboard.', {
    redirectUrl: redirectUrl,
  })
  return <Redirect to={redirectUrl} />
}

const onLoading = (): React.ReactNode => {
  return <Loading size={'large'} />
}

export function CognitoCallbackPage(props: RouteComponentProps) {
  const { login, logout } = useAppState()
  const { redirect_path } = queryString.parse(props.location.search)

  const handleAuthentication = async (props: RouteComponentProps) => {
    try {
      log('Handling Cognito callback')
      console.log('cognitoAuth', cognitoAuth)

      // Get the JWT from Cognito
      const jwt = await cognitoAuth.handleAuthCallback()
      console.log('jwt', jwt)

      // Login with the JWT (this will set up the user session)
      login(jwt)

      log('Cognito callback handled successfully, redirecting to onboard')
      return Links.onboard()
    } catch (error) {
      console.log('error', error)
      log('Error handling Cognito callback', { error })
      throw error instanceof Error ? error : new Error('Authentication failed')
    }
  }

  const onError = (err: any): React.ReactNode => {
    log('unable to correctly retrieve Cognito authentication credentials from URL.')
    return (
      <Result
        status="500"
        title="Oops something went wrong"
        subTitle="We were unable to log you in. Try again"
        extra={
          <Button
            type="primary"
            onClick={() => {
              logout()
              window.location.replace(Links.cognitoLogin())
            }}
          >
            Back to login
          </Button>
        }
      />
    )
  }

  return (
    <AsyncComponent
      id={'cognito-'}
      worker={() => handleAuthentication(props) as any}
      onLoading={onLoading}
      onSuccess={() => onSuccessRedirection(redirect_path as string)}
      onError={onError}
    />
  )
}
